<template>
  <div class="day-grid" ref="trackContainer">
    <div class="timeline-week" v-for="(week, indexW) in weeks" :key="week.weekNumber">
      <div class="timeline-day" v-for="(day, indexD) in week.days" 
        :key="day.weekDay" 
        :class="{  allFree: day.isAllFree, today: day.isToday, saturday: day.isSaturday, weekend: day.isWeekend || day.isHoliday, first: day.isFirst, hover: hoverIndexW === indexW && hoverIndexD === indexD }"></div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import { mapActions, mapGetters } from "vuex";
export default {
  name: "ScheduleDayGrid",
  props: {
    selectedDate: {
      type: Date, 
      default() {
        return new Date();
      },
    },
    zoomLevel: {
      type: Number,
      default: 1,
      validator: function (value) {
        // The value must be 1 or 2
        return [1,2].indexOf(value) !== -1
      },
    },
  },
  data: () => ({
    groupFilter: null,
    holidayLookUp: [],
    hoverIndexW: -1,
    hoverIndexD: -1,
  }),
  async mounted() {
    if(!this.holidays || this.holidays.length === 0) {
      await this.getHolidays();
    }

    if(this.holidays && this.holidays.length > 0 && (!this.holidayLookUp || this.holidayLookUp.length === 0)) {
      this.holidayLookUp = [];
      for(const h of this.holidays) {
        this.holidayLookUp.push({dateString: moment(h.date).format("YYYY-MM-DD"), allFree: h.state === 1});
      }
    }
  },
  created() {
    document.getElementsByTagName("body")[0].addEventListener("mousemove", this.mouseMoving);
  },
  beforeDestroy() {
    document.getElementsByTagName("body")[0].removeEventListener("mousemove", this.mouseMoving);
  },
  computed: {
    ...mapGetters("holidayStore", ["holidaysApiState", "holidays"]),
    weeks() {
      var weeks = [];
      var startDate = moment.utc(this.selectedDate);
      startDate = startDate.add(-startDate.isoWeekday() + 1, 'days');

      var weeksToGenerate = this.zoomLevel * 8;
      var indexDate = moment.utc(startDate);
      for (let w = 0; w < weeksToGenerate; w++) {
        weeks.push({
            days: [],
            weekNumber: indexDate.week(),
            year: indexDate.year(),
          });

        for (let d = 0; d < 7; d++) {
          const dateString = indexDate.format('YYYY-MM-DD');
          const isHoliday = this.holidayLookUp.find(o => o.dateString === dateString);
          const isAllFree = this.holidayLookUp.find(o => o.dateString === dateString && o.allFree);
          weeks[w].days.push({
            date: indexDate,
            weekDay: indexDate.isoWeekday(),
            isWeekend: indexDate.isoWeekday() === 7,
            isSaturday: indexDate.isoWeekday() === 6,
            isHoliday: isHoliday,
            isAllFree: isAllFree,
            isToday: indexDate.isSame(moment(), 'date'),
            isFirst: indexDate.date() === 1,
          });
          // Increment the index date
          indexDate = moment(indexDate).add(1, 'days');
        }
      }
      return weeks;
    },
  },
  methods: {
    ...mapActions("holidayStore", ["getHolidays"]),
    mouseMoving(event) {
      let offsetLeft = 419 + this.$refs.trackContainer.offsetLeft;
      let index = Math.floor((event.clientX - offsetLeft) / ((this.zoomLevel === 1) ? 48 : 24));
      if (index >= 0 && index !== this.hoverIndex) {
        const w = Math.floor(index / 7);
        const d = index % 7;
        
        if(this.hoverIndexW !== w) {
          this.hoverIndexW = w;
        }

        if(this.hoverIndexD !== d) {
          this.hoverIndexD = d;
        }
      }
      else if (index < 0) {
        if(this.hoverIndexW !== -1) {
          this.hoverIndexW = -1;
        } 
        
        if(this.hoverIndexD !== -1) {
          this.hoverIndexD = -1;
        }                 
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.timeline-day {
  &.weekend {
    background: #979797;
  }
  &.weekend.hover {
    background: #b7b7b7;
  }
  &.today {
    background: #ebf5ff;
  }
  &.today.hover {
    background: #cbd5ef;
  }
  &.saturday {
    background: #cacaca;
  }
  &.saturday.hover {
    background: #aaa;
  }
  &.allFree {
    background: #747474;
  }
  &.allFree.hover {
    background: #686868;
  }
}
</style>

